// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1_TCj","cls2":"News-cls2_bwM News-cls1_TCj"};